module.exports = __webpack_public_path__ + "img/product_53.4424890.webp";